export default "/images/59e96dc677c73bbaffdc9ce823060d3c.avif";